module.exports = __webpack_public_path__ + "static/media/RCS.5966b6c3.png";